const template = `
<div class="bottom-conditions">
	<form>
		<div class="conditions-container dividend-reduction">
			<h2>%dividend-reduction%</h2>
			<div class="conditions-inner">
				<div class="rows">
					<table data-sticky-template="bottom-conditions-dividend-reduction-inner">
						<tr>
							<td class="align-top">

								<div class="section update-wrapper">
									%dividend-updated-at% <button type="button">%button-update%</button>
								</div>

								<div class="section show-if-full-dividend-reduction">
									<h4>%winning-row%</h4>
									<div class="container-winners">
										<input type="number" inputmode="numeric" class="tipped-winner plain" name="dividendReduction[tippedWinners][%row-number%]" data-row="%row-number%" data-sticky-template="bottom-conditions-dividend-reduction-winners" value="" min="-1" max="99">
									</div>
									<div class="possible-correct">
										%possible-correct%
									</div>
								</div>

								<table class="section show-if-full-dividend-reduction">
									<tr>
										<td></td>
										<td class="dividend-jackpot-type">%estimated-pot%</td>
										<td class="dividend-jackpot-type">%estimated-count%</td>
										<td class="dividend-jackpot-type">%estimated-dividend-reduction%</td>
										<td class="dividend-jackpot-type">%estimated-nr-of-win-rows%</td>
										<td class="dividend-jackpot-type">%estimated-system-win-jackpot%</td>
									</tr>
									<tr>
										<td class="bold">%dividend-reduction-jackpot%</td>
										<td class="dividend-jackpot-type"><input type="text" class="jackpot w90" name="dividendReduction[jackpot]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-count w90" name="dividendReduction[estimatedCount]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-dividend-reduction w90" name="dividendReduction[estimatedDividend]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-winning-rows w90" name="dividendReduction[nrOfWinningRows]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-system-win w90" name="dividendReduction[systemJackpot]" disabled></td>
									</tr>
									<tr class="show-if-one-error-available">
										<td class="bold">%dividend-reduction-one-error%</td>
										<td class="dividend-jackpot-type"><input type="text" class="one-error w90" name="dividendReduction[oneError]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-count-one-error w90" name="dividendReduction[estimatedCountOneError]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-dividend-reduction-one-error w90" name="dividendReduction[estimatedDividendOneError]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-winning-rows-one-error w90" name="dividendReduction[nrOfWinningRowsOneError]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-system-win-one-error w90" name="dividendReduction[systemOneError]" disabled></td>
									</tr>
									<tr class="show-if-two-error-available">
										<td class="bold">%dividend-reduction-two-error%</td>
										<td class="dividend-jackpot-type"><input type="text" class="two-error w90" name="dividendReduction[oneError]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-count-two-error w90" name="dividendReduction[estimatedCountOneError]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-dividend-reduction-two-error w90" name="dividendReduction[estimatedDividendOneError]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-winning-rows-two-error w90" name="dividendReduction[nrOfWinningRowsOneError]" disabled></td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-system-win-two-error w90" name="dividendReduction[systemOneError]" disabled></td>
									</tr>
									<tr class="show-if-one-error-available">
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td>%dividend-reduction-total%</td>
										<td class="dividend-jackpot-type"><input type="text" class="estimated-system-win-total w90" name="dividendReduction[systemTotal]" disabled></td>
									</tr>
								</table>

								<div class="section show-if-full-dividend-reduction">
									<div class="locked-overlay-part" data-locked-overlay></div>
									<h4 class="play-expected-outcome">%condition%</h4>
									<table>
										<tr>
											<td colspan="2">
												<span class="condition-radio-wrapper"><input type="radio" id="condition-0-error" name="dividendReduction[]" value="0" class="allowed-errors"><label for="condition-0-error">%dividend-reduction-jackpot%</label></span>
												<span class="condition-radio-wrapper show-if-one-error-available-radio"><input type="radio" id="condition-1-error" name="dividendReduction[]" value="1" class="allowed-errors"><label for="condition-1-error">%dividend-reduction-one-error%</label></span>
											</td>
										</tr>
										<tr>
											<td>%min%</td>
											<td>%max%</td>
										</tr>
										<tr>
											<td><input type="number" inputmode="numeric" class="min-condition w90" min="-1" name="dividendReduction[minCondition]"></td>
											<td><input type="number" inputmode="numeric" class="max-condition w90" min="-1" name="dividendReduction[maxCondition]"></td>
										</tr>
									</table>
								</div>

								<div class="section show-if-full-dividend-reduction show-if-v6-available">
									<div class="locked-overlay-part" data-locked-overlay></div>
									<h4>%v6condition%</h4>
									<table>
										<tr>
											<td>%min%</td>
											<td>%max%</td>
										</tr>
										<tr>
											<td><input type="number" inputmode="numeric" class="min-v6-condition w90" min="-1" name="dividendReduction[minV6Condition]"></td>
											<td><input type="number" inputmode="numeric" class="max-v6-condition w90" min="-1" name="dividendReduction[maxV6Condition]"></td>
										</tr>
									</table>
									<div class="v6-v7-disabled-text">%v6-disabled-text%</div>
								</div>

								<div class="section show-if-full-dividend-reduction show-if-v7-available">
									<div class="locked-overlay-part" data-locked-overlay></div>
									<h4>%v7condition%</h4>
									<table>
										<tr>
											<td>%min%</td>
											<td>%max%</td>
										</tr>
										<tr>
											<td><input type="number" inputmode="numeric" class="min-v7-condition w90" min="-1" name="dividendReduction[minV7Condition]"></td>
											<td><input type="number" inputmode="numeric" class="max-v7-condition w90" min="-1" name="dividendReduction[maxV7Condition]"></td>
										</tr>
									</table>
									<div class="v6-v7-disabled-text">%v7-disabled-text%</div>
								</div>

								<div class="section">
									<div class="locked-overlay-part" data-locked-overlay></div>
									<h4 class="target-win-header">%target-win-header%</h4>
									<div class="target-win-text">%target-win-text%</div>
									<input type="number" inputmode="numeric" class="target-win-condition w90" min="-1" name="dividendReduction[targetWin]">
								</div>

							</td>
							<td class="align-top">
								<table class="statistics">
									<tr data-sticky-template="bottom-conditions-dividend-reduction-statistics-row">
										<td>%col1%</td>
										<td>%col2%</td>
										<td>%col3%</td>
										<td><div class="bar" style="width:%col4%px;"></div></td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
				</div>
			</div>
			<p>%bottom-conditions-dividend-reduction-disclaimer-atg%</p>
		</div><!-- CONTAINER -->

		<input type="submit" class="submit">
	</form>
</div>
`;

export default template;
